// extracted by mini-css-extract-plugin
export default {"editButton":"fixedAllowance_editButton__1n9+3","TableBody":"fixedAllowance_TableBody__UMQNc"};